import React, { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import ar from "./ar.json";
import en from "./en.json";

const DICTS = { ar, en };
export const SUPPORTED_LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: (k) => k, dict: ar });

const getValue = (obj, path) => {
  if (!path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (acc == null) return undefined;
    return acc[key];
  }, obj);
};

export function I18nProvider({ children }) {
  const { lang: rawLang } = useParams();
  const lang = SUPPORTED_LANGS.includes(rawLang) ? rawLang : DEFAULT_LANG;
  const dict = DICTS[lang];

  const value = useMemo(() => {
    const t = (key, fallback = "") => {
      const val = getValue(dict, key);
      if (val === undefined || val === null) return fallback || "";
      return val;
    };
    return { lang, t, dict };
  }, [lang, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
